import {Component} from '@angular/core';
import {Observable, of, tap} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {PaymentService} from "../../core/services/routes-services/payment.service";
import {PaymentInfo} from "../../core/interfaces/payment.interface";
import {BaseSelect} from "../../core/classes/base.component";

@Component({
    selector: 'app-payment-select',
    templateUrl: './payment-select.component.html',
    styleUrls: ['./payment-select.component.scss']
})
export class PaymentSelectComponent extends BaseSelect<PaymentInfo> {

    constructor(
        private service: PaymentService
    ) {
        super()
    }

    override executeRequest(): Observable<any> {
        return this.service.getPaymentsList(this.request()).pipe(
            map(res => this.processResponse(res)),
            catchError(() => of([])), // empty list on error
            tap(() => (this.loading = false)),
        )
    }

    override fill(filters: any) {
        super.fillBasicFilters(filters, 'PAYMENT')
    }

}
